import BigNumber from 'bignumber.js';
import { Network } from '@kattana-io/common';
import { getNetworkFlags } from '../../../wallet/helpers';
import { ICoin } from '../reducers/dex/tradingReducer';
import {
  isEVMAddress,
  isElrondAddress,
  isTonAddress,
} from '../../../helpers/checksumAddress';

const getPercentFromBalance = (balance: number, percent: number) => {
  try {
    const percentFromMaxBalance = BigNumber(balance).times(percent).toNumber();
    return percentFromMaxBalance;
  } catch (e) {
    console.error(e);
    return 0;
  }
};

const canGetEVMBalance = (chainId: number, token: ICoin, wAddress: string) => {
  const { isEVM: isEVMChain } = getNetworkFlags(chainId);
  const isEVMWallet = isEVMAddress(wAddress);

  return (
    isEVMChain &&
    isEVMWallet &&
    Network.fromChain(token.chain).toDecimal() === chainId
  );
};

const canGetElrondBalance = (
  chainId: number,
  token: ICoin,
  wAddress: string
) => {
  const { isElrond: isElrondChain } = getNetworkFlags(chainId);
  const isElrondWallet = isElrondAddress(wAddress);

  return (
    isElrondChain &&
    isElrondWallet &&
    Network.fromChain(token.chain).toDecimal() === chainId
  );
};

const canGetTonBalance = (chainId: number, token: ICoin, wAddress: string) => {
  const { isTon: isTonChain } = getNetworkFlags(chainId);
  const isTonWallet = isTonAddress(wAddress);

  return (
    isTonChain &&
    isTonWallet &&
    Network.fromChain(token.chain).toDecimal() === chainId
  );
};

export {
  canGetEVMBalance,
  canGetElrondBalance,
  canGetTonBalance,
  getPercentFromBalance,
};
